/**
 * LabelOffIcon/index.js
 * desc: label suppressed icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const LabelOffIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="label-off icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.labelOff.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 19" xmlns="http://www.w3.org/2000/svg"><path d="M1.59 2.97L0 1.38 1.44 0l16.97 16.97L17 18.38l-2-2H3c-1.1 0-2-.9-2-2v-10c0-.55.23-1.05.59-1.41zm14.04.25L20 9.38l-2.64 3.73L6.66 2.38H14c.67 0 1.27.33 1.63.84z"/></svg>
    </IconButton>
);


export default LabelOffIcon;
